import React, { useState } from "react";
import styles from "./changePass.module.css";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormikInput from "../../commonComponents/InputField/FormikInput";
import tostMessage from "../../utils/tostMessage";
import { postApi } from "../../services/apiService/fetchMethod";
import apiEndPoint from "../../services/apiService/apiEndPoints";
import LoaderCircle from "../../commonComponents/loader/LoaderCircle";
function ChangePass() {
  const [loading, setLoading] = useState(false);
  const initialVal = {
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  };

  const validationSchema = Yup.object().shape({
    oldPassword: Yup.string().required("This Field is required"),
    newPassword: Yup.string()
      .test(
        "password",
        "Password must contain at least one lowercase letter",
        value => /^(?=.*[a-z])/.test(value)
      )
      .test(
        "password",
        "Password must contain at least one uppercase letter",
        value => /^(?=.*[A-Z])/.test(value)
      )
      .test(
        "password",
        "Password must contain at least one digit",
        value => /^(?=.*\d)/.test(value)
      )
      .test(
        "password",
        "Password must contain at least one special character",
        value => /^(?=.*[@$!%*?&])/.test(value)
      )
      .test(
        "password",
        "Password must be at least 8 characters long",
        value => value.length >= 8
      )
      .required("This Field is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
      .required("This Field is required"),
  });
  

  const handleSubmit = async (val) => {
    setLoading(true);
    const { oldPassword, newPassword, confirmPassword } = val;
    let url = apiEndPoint().CHANGE_PASSWORD;
    const { status, data } = await postApi({
      url,
      params: {
        oldPassword,
        newPassword,
        confirmPassword,
      },
    });
    tostMessage(status, data?.message);
    setLoading(false);
    console.log(status, data);
  };
  return (
    <div>
      <h3 style={{ marginBottom: "2.5rem" }}>Change Password</h3>
      <div className={styles.cardWrapper}>
        <div className={styles.card}>
          <Formik
            initialValues={initialVal}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ touched, errors, setFieldValue, values, setFieldTouched }) => (
              <Form>
                <div style={{ marginBottom: "10px" }}>
                  <FormikInput
                    placeholder="Enter old password"
                    labelVal="Old Password"
                    name="oldPassword"
                    type="password"
                    touched={touched.oldPassword}
                    errors={errors.oldPassword}
                  />
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <FormikInput
                    placeholder="Enter new password"
                    labelVal="New Password"
                    name="newPassword"
                    type="password"
                    touched={touched.newPassword}
                    errors={errors.newPassword}
                  />
                </div>

                <FormikInput
                  placeholder="Confirm password"
                  labelVal="Confirm Password"
                  name="confirmPassword"
                  type="password"
                  touched={touched.confirmPassword}
                  errors={errors.confirmPassword}
                />
                <div
                  style={{
                    display: "flex",
                    marginTop: "1rem",
                    justifyContent: "end",
                  }}
                >
                  <button type="submit" className="buttonAddRole">
                    {loading ? <LoaderCircle size={20} /> : "Submit"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default ChangePass;
